// import React, { useState } from 'react'
// import { Row, Col } from '@/components/ui-compat'

import TenderForm from './components/TenderForm.tsx'
// import TenderStatus from './components/TenderStatus'

const Tender = () => {
  return <TenderForm />
}

export default Tender
